import { Navigate, useLocation } from "react-router-dom";
import ApplicationPageTemplate from "../components/application/ApplicationPageTemplate";
import { applicationPages } from "../data/applicationPagesData";

export default function ApplicationPage({ pageKey }) {
  const location = useLocation();
  const resolvedKey = pageKey || location.pathname.replace("/applications/", "");
  const page = applicationPages[resolvedKey];

  if (!page) {
    return <Navigate to="/" replace />;
  }

  return <ApplicationPageTemplate page={page} />;
}
